import {useAuth0} from "@auth0/auth0-react";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

const AuthPage = () => {
    const {loginWithRedirect, isAuthenticated, isLoading} = useAuth0();
    const navigate = useNavigate();
    const COPYRIGHT_YEAR = new Date().getFullYear();

    useEffect(() => {
        if (!isLoading && isAuthenticated) {
            navigate('/home');
        }
    }, [isAuthenticated, isLoading, navigate]);

    const handleGoogleLogin = async () => {
        await loginWithRedirect({
            appState: {returnTo: "/home"},
            authorizationParams: {connection: 'google-oauth2'}
        });
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 relative overflow-hidden">

            {/* The Login Card */}
            <div
                className="relative z-10 bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] w-full max-w-[420px] p-10 flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgb(0,0,0,0.1)]">

                {/* Logo */}
                <img
                    src={"/realmIcon.svg"}
                    alt="Realm Digital"
                    className="w-14 h-14 mb-6"
                />

                {/* Title */}
                <h1 className="text-2xl font-bold text-gray-900 mb-2">
                    Welcome to Power-Up
                </h1>

                {/* Subtitle */}
                <p className="text-gray-500 text-sm mb-8 leading-relaxed">
                    Recognize and celebrate your teammates at <br/> Realm Digital
                </p>

                {/* Divider */}
                <div className="w-full flex items-center gap-3 mb-8">
                    <div className="h-px bg-gray-200 flex-1"/>
                    <span className="text-xs text-gray-500 font-medium whitespace-nowrap">
                        Sign in to continue
                    </span>
                    <div className="h-px bg-gray-200 flex-1"/>
                </div>

                {/* Google Button */}
                <button
                    onClick={handleGoogleLogin}
                    className="w-full flex items-center justify-center gap-3 py-3 px-4 border border-gray-200 rounded-xl bg-white hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 group"
                >
                    <img
                        src="https://www.svgrepo.com/show/475656/google-color.svg"
                        alt="Google"
                        className="w-5 h-5"
                    />
                    <span className="text-gray-700 font-medium text-sm">
                        Continue with Google
                    </span>
                </button>

                {/* Footer Copyright */}
                <div className="mt-10 text-xs text-gray-400">
                    © Realm Digital {COPYRIGHT_YEAR}
                </div>
            </div>
        </div>
    );
};

export default AuthPage;
